<template>
  <div class="sign-field-cont" @click="!disabled ? openSignDialog() : ''"
    :style="'width:100%;height:100%;' + (disabled ? 'cursor:default;' : '')">
    <md-button :class="(val && (tab == tabIndex.DRAW || tab == tabIndex.PIC || tab == tabIndex.DEVICE)) ? 'img-sign' : ''"
      style="height: 100%; margin:0; width:100%;" :disabled="disabled">
      <div style="display: flex; width: 100%;height: 100%;">

        <div v-if="!val && !text" class="label" style="padding-left: 0;">{{ (label || "Text") + (required ? ' *' : '') }}</div>
        <div v-if="(val || text)" :id="'text-content-' + index" class="content"
          :style="'font-size: ' + fontSize + 'px;color:' + fontColor + '; font-family:' + font">
          {{ text
          }}
        </div>

      </div>
      <md-icon style="margin: auto 0; position: absolute;top: 50%;
    transform: translateY(-50%);
    right: 0px;
    padding-top: 10px;" v-if="!disabled && !val">text_format</md-icon>
    </md-button>
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" :md-close-on-esc="false"
      class="custom-text-field-dialog">
      <md-dialog-title>
        Text field
      </md-dialog-title>
      <div style="margin: 25px;">

        <md-field md-inline md-clearable>
          <label>Type here</label>
          <md-input v-model="text"
            :style="'font-size: ' + fontSize + 'px;-webkit-text-fill-color:' + fontColor + ';font-family:' + font"></md-input>
        </md-field>

        <!-- div style="display:flex;">

           <v-swatches v-model="fontColor" popover-x="right" popover-y="top"         :swatches="swatches"

        row-length="6" style="    padding-top: 10px;     margin-right: 20px;"></v-swatches> -->
        <md-field>
          <label for="font">Font</label>

          <md-select v-model="font" name="font" id="font" :style="'font-family:' + font">
            <!-- <md-option v-for="fontOpt in fonts" v-bind:key="creator.id" :value="creator.id"> {{ creator.firstName + ' ' + creator.lastName + ' (' + creator.email + ')'}}</md-option> -->
            <md-option style="font-family:'Pattaya'" value="Pattaya">Pattaya</md-option>
            <md-option style="font-family:'Garamond'" value="Garamond">Garamond</md-option>
            <md-option style="font-family:'Comic Sans MS'" value="Comic Sans MS">Comic Sans MS</md-option>
            <md-option style="font-family:'Helvetica'" value="Helvetica">Helvetica</md-option>
            <md-option style="font-family:'Bradley Hand ITC'" value="Bradley Hand ITC">Bradley Hand ITC</md-option>
            <!-- <md-option value="Pattaya">Pattaya</md-option> -->
            <!-- <md-option style="font-family:Pattaya" value="Pattaya">Pattaya</md-option>
            <md-option style="font-family:Pacifico" value="Pacifico">Pacifico</md-option>
            <md-option style="font-family:Great Vibes" value="Great Vibes">Great Vibes</md-option>
            <md-option style="font-family:Serif" value="Serif">Serif</md-option>
            <md-option style="font-family:Indie Flower" value="Indie Flower">Indie Flower</md-option> -->
            <!-- <md-option style="font-family:Roboto" value="Roboto">Roboto</md-option> -->
          </md-select>
          <LvColorpicker v-model="fontColor" withoutInput hidePalette />
        </md-field>
        <div>
          <md-button @click="() => { if (fontSize < 32) { fontSize += 2 } }"><md-icon>text_increase</md-icon></md-button>
          <md-button @click="() => { if (fontSize > 6) { fontSize -= 2 } }"><md-icon>text_decrease</md-icon></md-button>
        </div>

        <!-- </div>-->

      </div>

      <md-dialog-actions>
        <md-button class="md-raised" @click="tab = lastValidType;
        text = initText;
        font = initFont;
        fontColor = initColor;
        showDialog = false;">Close</md-button>
        <md-button class="md-primary md-raised" :disabled="disableSave" @click="onSaveSign()">Save</md-button>

      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
// import Vue from "vue";
// import SignaturePad from "signature_pad";
import axios from "axios";
import domtoimage from 'dom-to-image';
import QRCode from 'qrcode'
// import VSwatches from 'vue-swatches'

export default {
  name: "SignField",
  components: {
    //VSwatches
  },
  data() {
    return {
      showBg: false,
      lastValidType: null,
      fontSize: 18,
      dotSize: 2,
      initText: '',
      initFont: '',
      initColor: '',
      fontColor: '#000000',
      font: 'Pattaya',
      swatches: ['blue', 'red', 'green', 'orange', 'black', 'gray'],
      copied: false,
      deviceImg: "",
      showDialog: false,
      tabIndex: {
        DRAW: 0,
        TEXT: 1,
        PIC: 2,
        CODE: 3,
        DEVICE: 4,
      },
      emptyPad: true,
      tab: 0,
      text: "",
      val: this.value || null,
      pic: null,
      validCode: false,
      qrImage: '',
      mobileSignUrl: ''
    };
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    index: Number,
    height: Number,
    width: Number,
    label: String,
    required: Boolean,
    disabled: Boolean,
    signMethods: Array,
    value: [Object, String],
    signType: { type: Number, default: 0 },
  },
  computed: {
    disableSave() {
      var disabled = true;
      disabled = this.required && !this.text;
      // switch (this.tab) {
      //   case this.tabIndex.DRAW:
      //     disabled = this.emptyPad;
      //     break;
      //   case this.tabIndex.TEXT:
      //     disabled = !this.text;
      //     break;
      //   case this.tabIndex.PIC:
      //     disabled = !this.pic;
      //     break;
      //   case this.tabIndex.CODE:
      //     disabled = !this.validCode;
      //     break;
      //      case this.tabIndex.DEVICE:
      //     disabled = !this.deviceImg;
      //     break;
      // }
      return disabled;
    },
  },
  mounted() {
    var vm = this;
    vm.mobileSignUrl = location.host + '/' + (process.env.VUE_APP_BASE_WEB || 'cartago-digital') + '/signmobile?transactionId=' + vm.$route.query.transactionId;
    // this.tab=this.signType;
    setTimeout(function () {
      QRCode.toDataURL(vm.mobileSignUrl, function (err, url) {
        console.log(url)
        vm.qrImage = url;

        //   var imgPdf = document.getElementById("pdf-image");


        //   var canvas = document.getElementById('myCanvas');
        //       var context = canvas.getContext('2d');
        //       var imageObj = new Image();

        //       var context = canvas.getContext('2d');
        //     var imageObj = new Image();

        //     imageObj.onload = function() {
        //         // crop from 0,0, to 250,150
        //         var cropX = 0;
        //         var cropY = 0;
        //         var cropWidth = width*2;
        //         var cropHeight = height*2;



        //         //resize our canvas to match the size of the cropped area
        //         canvas.style.width = cropWidth;
        //         canvas.style.height = cropHeight;

        //         //fill canvas with cropped image
        //         context.drawImage(imageObj, cropX, cropY, cropWidth, cropHeight, 0, 0, canvas.width, canvas.height);
        // };
        // imageObj.src = imgPdf.src;




      })

    }, 0)

    setInterval(function () {

      QRCode.toDataURL(vm.mobileSignUrl + '&token=' + Date.now(), function (err, url) {

        vm.qrImage = url;
      })

    }, 15000);
  },
  methods: {
    copyPhoneLink() {


      var dummy = document.createElement("input");

      document.body.appendChild(dummy);
      dummy.value = this.mobileSignUrl;
      dummy.select();
      dummy.setSelectionRange(0, 99999);
      document.execCommand("copy");
      document.body.removeChild(dummy);
      this.copied = true;
    },
    onBegin() {
      console.log("=== Begin ===");
      this.emptyPad = false;
      this.$refs.signaturePad.resizeCanvas()
    },
    onEnd() {
      console.log("=== End ===");
    },
    clearPad() {
      this.$refs.signaturePad.clearSignature();
      this.emptyPad = true;
    },
    changedTab() {
      var vm = this;
      var ws = vm.ws;
      console.log("aaaa" + this.tab);
      if (this.tab == this.tabIndex.DEVICE) {
        //          axios.get('http://localhost:3001/sign/api/send_img')

        //       .then(response => {  vm.deviceImg=response;
        //       })
        //         const ws = new WebSocket('ws://localhost:9898/');

        //         ws.onopen= function(){
        // console.log('WebSocket Client Connected');
        // ws.send('Hi this is web client');
        //         };
        //         ws.onmessage = function(e){
        //           vm;
        //           console.log(e);
        //           if(e.data){

        //             vm.deviceImg=e.data;
        //           }
        //           console.log("Received: '"+e.data+"'");
        //         }

        ////////////////////////////////////////
        axios;
        if (!ws) {//VUE_APP_BASE_WEB
          // ws = new WebSocket("ws://"+location.host+"/");
          ws = new WebSocket(((window.location.protocol == "https:") ? 'wss' : 'ws') + "://" + location.host + "/" + (process.env.VUE_APP_BASE_WEB || 'cartago-digital'));

          ws.onopen = function () {
            console.log("WS Connection opened");
            ws.send('');
          };

          ws.onmessage = function (data) {
            console.log(data);
            if (data.data) {

              vm.deviceImg = data.data;
              ws.close();
            }
          };

          // ws.onclose
        }
      }
    },
    onChangePicture(image) {
      this.pic = image;
      console.log(image);
    },
    onSaveSign() {
      const vm = this;
      vm.lastValidType = this.tab;
      this.showDialog = false;
      // this.signType=this.tab;
      if (!vm.text) {
        vm.val = null;
        vm.$emit("change", null);
        vm.$emit("rawValue", null);
        vm.$emit("fieldProps", null);
        return;
      }

      setTimeout(function () {

        // var node = document.querySelector('div.content');

        console.log('div#text-content-' + vm.index);
        var node = document.querySelector('div#text-content-' + vm.index);
        //  let scale =2;
        // domtoimage.toPng(node,{
        //     height: node.offsetHeight * scale,
        //     width: node.offsetWidth * scale,
        //     style: {
        //     transform: "scale(" + scale + ")",
        //     transformOrigin: "top left",
        //     width: node.offsetWidth + "px",
        //     height: node.offsetHeight + "px"
        //     }})
        domtoimage.toPng(node).then(function (dataUrl) {


          var image = new Image();
          image.onload = function () {
            // create an off-screen canvas
            var canvas = document.createElement('canvas'),
              ctx = canvas.getContext('2d');

            // set its dimension to target size
            canvas.width = vm.width;
            canvas.height = vm.height;

            // draw source image into the off-screen canvas:
            ctx.drawImage(image, 0, 0);

            // encode image to data-uri with base64 version of compressed image
            dataUrl = canvas.toDataURL();
            console.log(dataUrl)
            vm.val = dataUrl;
            vm.$emit("change", vm.val);
            vm.$emit("rawValue", vm.text);
            vm.$emit("fieldProps", {color:vm.fontColor,
              font:vm.font
            });
          };
          image.src = dataUrl;







        })
          .catch(function (error) {
            console.error(error);
            vm.showDialog = true;
          });


      }, 0);


      this.$emit("change", this.val);
       this.$emit("rawValue", this.text);
           this.$emit("fieldProps", {color:this.fontColor,
              font:this.font
            });
    },
    openSignDialog() {
      var vm = this;
      vm.initText = vm.text;
      vm.initFont = vm.font;
      vm.initColor = vm.fontColor;
      var activeTab = this.tab || 0;
      this.showDialog = true;
      setTimeout(function () {
        document.querySelectorAll(".signTabs .md-tab-nav-button")[activeTab].click();
        // document.querySelector('.md-dialog').appendChild(document.querySelector('.vue-swatches__container'));
        vm.disableSave;
      }, 0);
      this.$nextTick(() => {
        this.$refs.signaturePad.resizeCanvas();
      });
      setTimeout(function () {
        // const container = document.querySelector("#signature-pad-cont");
        // var signSpan = document.createElement("span");
        // var signCanvas = document.createElement("canvas");
        // signCanvas.id = "signature-pad";
        // signCanvas.width = 500;
        // signCanvas.height = 200;
        // signCanvas.style = "max-width:unset; border: 1px solid;";
        // signSpan.appendChild(signCanvas);
        // container.appendChild(signSpan);
        // new SignaturePad(signCanvas);
      }, 0);
    },
  },
};
</script>

<style lang="scss">
.lv-overlaypanel {
  translate: 15px -30px;
}


.vc-editable-input {
  font-family: "Montserrat", Avenir, Helvetica, Arial, sans-serif;
}

// @import url('https://fonts.googleapis.com/css?family=Pacifico');

/* latin-ext */
@font-face {
  font-family: 'Pacifico';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/pacifico/v22/FwZY7-Qmy14u9lezJ-6J6MmTpA.woff2) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: 'Pacifico';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/pacifico/v22/FwZY7-Qmy14u9lezJ-6H6Mk.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

// @import url('https://fonts.googleapis.com/css?family=Great+Vibes');

/* latin-ext */
@font-face {
  font-family: 'Great Vibes';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/greatvibes/v14/RWmMoKWR9v4ksMfaWd_JN9XLiaQ6DQ.woff2) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: 'Great Vibes';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/greatvibes/v14/RWmMoKWR9v4ksMfaWd_JN9XFiaQ.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}


// @import url('https://fonts.googleapis.com/css?family=Indie+Flower');

/* latin */
@font-face {
  font-family: 'Indie Flower';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/indieflower/v17/m8JVjfNVeKWVnh3QMuKkFcZVaUuH.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

//Pattaya

/* latin-ext */
@font-face {
  font-family: 'Pattaya';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/pattaya/v7/ea8ZadcqV_zkHY-XBdmt9lZE.woff2) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: 'Pattaya';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/pattaya/v7/ea8ZadcqV_zkHY-XBdet9g.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

.sign-field-cont {
  position: absolute;
  background: white;
  cursor: pointer;

  .label,
  .content {
    text-transform: none;
    // border-bottom: 1px solid #757575;
    padding: 8px;
    width: 100%;
    text-align: left;
  }

  .content {
    font-family: "Pattaya", "Times New Roman", Times, serif;
    font-size: 28px;
    color: blue;
  }
}

.md-content.md-tabs-content {
  margin: 20px;
}

#signature {
  margin: 0 auto;
  border: 1px solid;
}

.sign-field-cont .md-ripple {
  justify-content: start;
  display: block;
  padding: 0 !important;
  color: rgba(0, 0, 0, 0.54);
  font-family: "Montserrat", 'Avenir', 'Helvetica', 'Arial', 'sans-serif';
  font-size: 16px;
  font-weight: 400;
}

.md-tab {
  overflow: hidden;
}

.sign-field-cont .img-sign .md-button-content {
  height: 100%;
}

.picture-inner {
  height: calc(100% - 20px) !important;
  margin: 10px auto !important;
  padding: 0 !important;
}

.img-pic {
  object-fit: cover !important;
}

.custom-text-field-dialog .md-dialog-container {
  min-width: 600px;
}
</style>